import React from 'react';
import '../../styles/components/dashboard/user-summary.scss';
import {NavLink} from "react-router-dom";
import {appPagePaths} from "../../config/config";
import {FontIcon} from "../common/FontIcon";
import {DashboardUserCurrentLevel} from "../../modules/dashboard/user-current-level/DashboardUserCurrentLevel";
import {DashboardUserTotalPoints} from "../../modules/dashboard/user-total-points/DashboardUserTotalPoints";
import {DashboardUserPointsToLevel} from "../../modules/dashboard/user-points-to-level/DashboardUserPointsToLevel";
import {useSelector} from 'react-redux';
import {dateLongFromIso8601, dateShortFromIso8601,} from "../../factories/dateFactory";
import {myProfileStore} from "../../redux/my-profile/myProfileStore";


export default function UserSummary() {
  const username = useSelector(myProfileStore.getMyProfileUsername);
  const joinedAt = useSelector(myProfileStore.getMyProfileJoinedAt);

  return (
    <section className={`user-summary`}>
      <NavLink className={`username-link`} to={appPagePaths.settingsPage} aria-label={`Go to Account settings`}><h2 className={`username`}>{username}</h2><FontIcon icon={`icon-arrow-right`}></FontIcon></NavLink>
      <p className={`user-join-date`}>Member since <time dateTime={dateShortFromIso8601(`${joinedAt}`)}>{dateLongFromIso8601(`${joinedAt}`)}</time></p>
      <dl className={`summary-stats`}>
        <DashboardUserTotalPoints />
        <DashboardUserCurrentLevel />
        <DashboardUserPointsToLevel />
      </dl>
    </section>
  )
}
